import { FC, useCallback, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Routes } from '@/_shared/constants/routes';
import { DocumentPlayer } from '../components/DocumentPlayer';

type LocationState = {
  documentUrl: string;
  title?: string;
  startFrom?: number;
};

export const DocumentScreen: FC = () => {
  const { documentId } = useParams<{ documentId: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as LocationState | undefined;

  const onDocumentClose = useCallback(() => {
    navigate(-1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [navigate]);

  // If no state is provided, redirect back to training
  useEffect(() => {
    if (!state?.documentUrl) {
      navigate(Routes.TrainingHardSkills, { replace: true });
    }
  }, [navigate, state?.documentUrl]);

  if (!state?.documentUrl || !documentId) {
    return null;
  }

  return (
    <>
      <DocumentPlayer
        id={documentId}
        url={state.documentUrl}
        title={state.title}
        startFrom={state.startFrom}
        open
        onClose={onDocumentClose}
      />
      <ToastContainer style={{ zIndex: 99999999 }} />
    </>
  );
};
